import { render, staticRenderFns } from "./addClientBankCard.vue?vue&type=template&id=1fdcb9fe&scoped=true"
import script from "./addClientBankCard.vue?vue&type=script&lang=js"
export * from "./addClientBankCard.vue?vue&type=script&lang=js"
import style0 from "./addClientBankCard.vue?vue&type=style&index=0&id=1fdcb9fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdcb9fe",
  null
  
)

export default component.exports